import "./Home.module.css";
import MainMenu from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import HaarwerkenOpMaat from "./sections/HaarwerkenOpMaat";
import GeefUwInterieurEenTweedeLeven from "./sections/GeefUwInterieurEenTweedeLeven";
import MedischReisadvies from "./sections/MedischReisadvies";
import InspirationGallery from "./sections/InspirationGallery";
import Service from "./sections/Service";
import FixedRates from "./sections/FixedRates";
import OnzeKernwaarden from "./sections/OnzeKernwaarden";
import TrustedByLeaders from "./sections/TrustedByLeaders";
import MeetThePainters from "./sections/MeetThePainters";
import ClientExperiences from "./sections/ClientExperiences";
import OfferteConfigurator from "./sections/OfferteConfigurator";
import GoogleReview from "./sections/GoogleReview";
import FindKatbalou from "./sections/FindKatbalou";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainMenu />
      <Hero />
      <GeefUwInterieurEenTweedeLeven />
      <HaarwerkenOpMaat />
      <MedischReisadvies />
      <InspirationGallery />
      <Service />
      <FixedRates />
      <OnzeKernwaarden />
      <TrustedByLeaders />
      <MeetThePainters />
      <ClientExperiences />
      <OfferteConfigurator />
      <GoogleReview />
      <FindKatbalou />
      <Footer />
    </div>;
}